/**
 * CalendarInventoryConflictMode
 */
export enum CalendarInventoryConflictMode {
    EXCLUSIVE = 'exclusive',
    SHARED = 'shared',
    WARNING = 'warning'
}
